import {
  FirstLastTranche,
  OpmSampleWaterfallInstrumentTranchesDto,
} from '@app/shared/models/contracts/opm-calculation-results-dto';
import { l } from '@locale/setupI18n';

type AllTrancheKeys = keyof FirstLastTranche | keyof OpmSampleWaterfallInstrumentTranchesDto;
type AllowedTrancheKeys = Omit<AllTrancheKeys, 'conditions'>;

export const getProceedsCapToolTipContent = (
  valueKey: AllowedTrancheKeys,
  hasHitCapValues: boolean[],
  hasReceivedEnhancedParticipationValues: boolean[]
): string | null => {
  if (
    valueKey === 'trancheDistribution' &&
    hasHitCapValues.some((hasHitCap) => hasHitCap === true)
  ) {
    return l('_HasHitCapTooltip');
  }
  if (
    valueKey === 'trancheParticipationPc' &&
    hasReceivedEnhancedParticipationValues.some(
      (hasReceivedEnhancedParticipation) => hasReceivedEnhancedParticipation === true
    )
  ) {
    return l('_HasReceivedEnhancedParticipationTooltip');
  }
  return null;
};
